import React from 'react';
import { navigate } from './Router';
import ThemeToggle from './ThemeToggle';
import { useTheme } from '../contexts/ThemeContext';

const PersonIcon = ({ className = '' }: { className?: string }) => (
  <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
  </svg>
);

interface HeaderProps {
  className?: string;
}

const Header: React.FC<HeaderProps> = ({
  className = ''
}) => {
  const { theme } = useTheme();
  const btnBg = theme === 'dark' ? 'bg-zinc-700 hover:bg-zinc-600' : 'bg-theme-secondary hover:bg-theme-hover';

  return (
    <header className={`flex flex-col md:flex-row md:justify-between md:items-start mb-4 md:mb-8 ${className}`}>
      {/* モバイル版 */}
      <div className="flex justify-between items-center mb-4 md:hidden">
        <a
          href="/"
          onClick={(e) => { e.preventDefault(); navigate('/'); }}
          className="text-left hover:opacity-80 transition-opacity"
        >
          <h1 className="text-3xl fira-sans-extra-bold-italic text-brand-primary">tikeda / ALT</h1>
          <p className="text-sm fira-sans-book-italic text-theme-tertiary mt-1">Daily life, reimagined by AI.</p>
        </a>
        <div className="flex items-center gap-1">
          <a
            href="/about"
            onClick={(e) => { e.preventDefault(); navigate('/about'); }}
            className={`inline-flex items-center justify-center w-8 h-8 p-1 rounded-lg transition-all duration-200 ${btnBg} border border-theme-primary text-theme-primary`}
            aria-label="About"
            title="About"
          >
            <PersonIcon className="w-4 h-4" />
          </a>
          <ThemeToggle className="w-8 h-8 p-1" />
        </div>
      </div>

      {/* デスクトップ版 */}
      <a
        href="/"
        onClick={(e) => { e.preventDefault(); navigate('/'); }}
        className="hidden md:block order-2 md:order-1 text-left hover:opacity-80 transition-opacity"
      >
        <h1 className="text-3xl sm:text-3xl lg:text-4xl fira-sans-extra-bold-italic text-brand-primary">tikeda / ALT</h1>
        <p className="mt-3 text-sm sm:text-base fira-sans-book-italic text-theme-tertiary">Daily life, reimagined by AI.</p>
      </a>

      <div className="hidden md:flex order-2 items-center gap-2">
        <a
          href="/about"
          onClick={(e) => { e.preventDefault(); navigate('/about'); }}
          className={`inline-flex items-center justify-center p-2 rounded-lg transition-all duration-200 ${btnBg} border border-theme-primary text-theme-primary`}
          aria-label="About"
          title="About"
        >
          <PersonIcon className="w-5 h-5" />
        </a>
        <ThemeToggle />
      </div>
    </header>
  );
};

export default Header;
